import 'vue-toastification/dist/index.css'
import { defineNuxtPlugin } from '#app'
import Toast from 'vue-toastification'

export default defineNuxtPlugin((nuxtApp) => {
  const options = {
    position: 'bottom-center',
    type: 'info',
  }

  nuxtApp.vueApp.use(Toast, options)
})
